import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    const isAuthenticated = !!localStorage.getItem('refreshToken'); // Controlla se esiste un token di autenticazione
    if (!isAuthenticated) {
      this.router.navigate(['/login']); // Reindirizza alla pagina di login se non autenticato
      return false;
    }
    return true;
  }
}
